import { Modal } from 'common/modal';
import { Input } from 'common/input';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { ModalPosition } from 'common/modal/modal';
import { useState } from 'react';
import styles from './modal-add-location.module.scss';

interface LocationModalProps {
  addNewLocation: (newLocation: string) => void;
  onClose: () => void;
  locationName: string;
}
export const LocationModal = ({
  addNewLocation,
  onClose,
  locationName,
}: LocationModalProps) => {
  const [newLocationName, setNewLocationName] = useState(locationName);
  const handleLocationNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewLocationName(e.target.value);
  };

  return (
    <Modal
      position={ModalPosition.Center}
      onClose={onClose}
      contentClassName={styles.modalContent}
      title="Create new location"
      closeOnOutsideClick
      contentDataAttributes={{ 'data-modal': 'location' }}
    >
      <Input
        value={newLocationName}
        onChange={handleLocationNameChange}
        id="location-name"
        label="Location name"
        placeholder="e.g. My treehouse"
      />
      <Button
        buttonStyle={ButtonStyle.Primary}
        buttonSize={ButtonSize.Large}
        onClick={() => addNewLocation(newLocationName)}
        disabled={newLocationName.length < 2}
      >
        Create
      </Button>
    </Modal>
  );
};
